export default __webpack_public_path__ + "./fonts/changeAccount.245ad613.svg";